module.exports = __webpack_public_path__ + "static/img/4.993e4ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/4.png
// module id = wCh6
// module chunks = 0